export default __webpack_public_path__ + "static/activation.url-15b2feb125f2357b7d5279df1e93d095.svg";